import { useContext } from 'react';
import { TimesheetModalsContext } from '../components/TimesheetModalContext';

export const useTimesheetModals = () => {
  const context = useContext(TimesheetModalsContext);
  return context;
};
